import { Calculator } from "lucide-react";
import type { LineageNode } from "../types";
import { NodeShell } from "./NodeShell";

interface Props {
  data: LineageNode;
  selected?: boolean;
}

export function CandidateScoringMatrixNode({ data, selected }: Props) {
  return <NodeShell node={data} icon={Calculator} selected={selected} />;
}
